import { MutationTree } from "vuex";
import { IAuthState } from "./interface";

export default <MutationTree<IAuthState>> {

	setAuth(state, payload: boolean) {
		state.isAuth = payload;
	},

	setCustomerSessionExpired(state, payload: boolean) {
		state.customerSessionExpired = payload;
	},

	setResetNotificationTrack(state, payload: boolean) {
		state.resetNotificationTrack = payload;
	},

	setCountRefreshRequestChange(state, payload: number) {
		state.countRefreshRequest = payload;
	}

}